import { render, staticRenderFns } from "./ImagesHandlerGrid.vue?vue&type=template&id=352fb7e9&scoped=true&"
import script from "./ImagesHandlerGrid.vue?vue&type=script&lang=js&"
export * from "./ImagesHandlerGrid.vue?vue&type=script&lang=js&"
import style0 from "./ImagesHandlerGrid.vue?vue&type=style&index=0&id=352fb7e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fb7e9",
  null
  
)

export default component.exports